<template>
  <div style="text-align: center; margin-top: 1rem">
    <span style="font-size: 1.1em; font-weight: bold">{{ variant.name }}</span>
    <span style="font-size: 1.1em; font-weight: bold; padding-left: 2rem"
      >{{ (variant.price + variant.vat).toLocaleString() }} Kč</span
    >
    <div v-if="itemState !== 'NOT_AVAILABLE'">
      <div v-if="variant.available">
        <div v-if="count > 0">
          <button type="button" v-on:click="cart(count - 1)" class="btn btn-secondary btn-circle">
            <font-awesome-icon icon="minus"></font-awesome-icon>
          </button>
          {{ count }}
          <button v-on:click="cart(count + 1)" class="btn btn-secondary btn-success btn-circle">
            <font-awesome-icon icon="plus"></font-awesome-icon>
          </button>
        </div>
        <div v-if="count == 0">
          <button class="btn btn-success" v-on:click="cart(count + 1)">
            <font-awesome-icon icon="shopping-cart"></font-awesome-icon>
            Do košíku
          </button>
        </div>
      </div>
      <div v-else>
        <span class="badge badge-danger">Nedostupné</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Variant",
  data: function() {
    return {
      count: 0,
    };
  },
  props: ["variant", "itemState"],
  methods: {
    cart: function(newCount) {
      if (newCount > 0) this.$set(this.cart, this.variant.extId, newCount);
      else this.$delete(this.cart, this.variant.extId);
      this.count = newCount;
      var cartData = {};
      cartData.extId = this.variant.extId;
      cartData.count = this.count;

      this.$store.dispatch("updateCart", cartData);
    },
  },
  created() {
    var self = this;
    this.$store
      .dispatch("fetchCart")
      .then(
        self.$store.state.cart.forEach((element) => {
          if (element.extId === self.variant.extId) {
            self.count = element.count;
          }
        })
      )
      .catch((err) => {
        self.$store.commit("addNotification", {
          text: "Chyba načtení položek košíku. " + err.message,
          type: "alert",
        });
      });
  },
};
</script>
